const PageApplication = require('../page/frontend/application');

import homeDesktopApplication from './desktop/frontend/application';

PageApplication.initialize();
homeDesktopApplication.initialize();
